import { render } from "./sf-flash.vue?vue&type=template&id=f91c3ac9"
import script from "./sf-flash.vue?vue&type=script&lang=js"
export * from "./sf-flash.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__